import { Badge, Checkbox, Form, Input, Space } from 'antd'
import React from 'react'
import PlusCircleOutlined from "@ant-design/icons/PlusCircleOutlined";
import MinusCircleOutlined from "@ant-design/icons/MinusCircleOutlined";
import './style.css'

const IpAccessDeatils = ({formUser}) => {
    const ipAddressDetails = Form.useWatch('ip_address', formUser);
    return (
        <div className='ipformitem-space'>
            {
                ipAddressDetails?.length == 0 ?
                <Badge status='success' text='User has All Access' style={{marginBottom:10}} />
                :
                <></>
            }
            <Form.Item
            noStyle
                // labelAlign="right"
                // label="Capacity"
                // name={['ip_access']}
            >
                <Form.List name={['ip_address']} initialValue={[{name:'Office', ip:''},{name:'Project Office', ip:''}]}>
                    {(fields, { add, remove }) => (
                        <>

                            {fields.map((field, index) => (
                                <div
                                    key={field.key}
                                    className='ipformitem-list'
                                    // align="baseline"
                                >
                                    <Form.Item
                                        
                                        name={[field.name, 'name']}
                                        style={{ marginBottom: 10 , width:'100%', marginRight:8}}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'required!',
                                            },
                                        ]}

                                    >
                                        <Input disabled></Input>
                                    </Form.Item>
                                    <Form.Item
                                        name={[field.name, 'ip_address']}
                                        style={{ marginBottom: 10, width:'100%', marginRight:8 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'required!',
                                            },
                                        ]}

                                    >
                                        <Input disabled></Input>
                                    </Form.Item>
                                    {/* {
                                        <>
                                            {field.name > 0 ? <MinusCircleOutlined style={{color:"red"}} onClick={() => remove(index)} /> : <PlusCircleOutlined style={{color:"blue"}} onClick={() => add()} />}
                                        </>
                                    } */}


                                </div>
                            ))}
                        </>
                    )}
                </Form.List>
            </Form.Item>
        </div>
    )
}

export default IpAccessDeatils